module.exports = __webpack_public_path__ + "img/bg.aec140e9.png";